import { MultiRootEditor } from 'ckeditor5';
import {
  createContext,
  FC,
  PropsWithChildren,
  useEffect,
  useMemo,
  useState,
} from 'react';

type QMultiRootEditorContextType = {
  editor: MultiRootEditor | null;
  setEditor: (editor: MultiRootEditor | null) => void;
  ccEditor: MultiRootEditor | null;
  setCCEditor: (editor: MultiRootEditor | null) => void;
};

export const QMultiRootEditorContext =
  createContext<QMultiRootEditorContextType>({} as any);

export const QMultiRootEditorContextProvider: FC<PropsWithChildren> = ({
  children,
}) => {
  const [editor, setEditor] = useState<MultiRootEditor | null>(null);
  const [ccEditor, setCCEditor] = useState<MultiRootEditor | null>(null);
  const value = useMemo(
    () => ({ editor, setEditor, ccEditor, setCCEditor }),
    [editor, ccEditor],
  );

  // TODO: remove once CKEditor tears down keystroke listener appropriately in
  const cleanupPresenceListUIKeystrokeListener = (
    editor: MultiRootEditor | null,
  ) => {
    if (!editor) {
      return;
    }
    const presenceListUI = editor.plugins.get('PresenceListUI') as any;
    presenceListUI?.view?.inlineListView?.keystrokes?.destroy();
  };

  useEffect(() => {
    return () => {
      cleanupPresenceListUIKeystrokeListener(editor);
      cleanupPresenceListUIKeystrokeListener(ccEditor);
    };
  }, [editor, ccEditor]);

  return (
    <QMultiRootEditorContext.Provider value={value}>
      {children}
    </QMultiRootEditorContext.Provider>
  );
};
